import React, { useEffect, useState } from 'react'
import { Btn, Cnpj, InputText, Loading } from '../../../../components'
import * as EmissoresHttp from '../../../../services/api/https/settings/emissor-cte.http'
import { errorHandler } from '../../../../services/util/error.service'

const TAMANHO_MAXIMO = 60 * 1024

const formatarData = valor => (valor ? new Date(valor).toLocaleDateString('pt-BR') : '-')

const estiloRotulo = { fontSize: '0.8rem', color: '#14B0BF', display: 'block' }

export default function CertificadoCiotTab({ emissor, onSalvo, onError }) {
  const [info, setInfo] = useState(null)
  const [carregando, setCarregando] = useState(false)
  const [enviando, setEnviando] = useState(false)
  const [senha, setSenha] = useState('')

  useEffect(() => {
    if (!emissor || !emissor.id) return
    let ativo = true
    setCarregando(true)
    setInfo(null)
    setSenha('')
    EmissoresHttp.getCertificadoEmissor(emissor.id)
      .then(resposta => ativo && setInfo(resposta))
      .catch(error => ativo && onError(errorHandler(error)))
      .finally(() => ativo && setCarregando(false))
    return () => {
      ativo = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emissor && emissor.id])

  if (!emissor || !emissor.id)
    return (
      <div style={{ padding: 10, fontSize: '0.9rem' }}>
        Salve o emissor na aba Dados antes de enviar o certificado.
      </div>
    )

  const enviarCertificado = async arquivo => {
    if (arquivo.size > TAMANHO_MAXIMO)
      return onError('Arquivo grande demais para um certificado A1')
    setEnviando(true)
    try {
      const salvo = await EmissoresHttp.saveCertificadoEmissor(emissor.id, arquivo, senha)
      setInfo(salvo)
      setSenha('')
      onSalvo(salvo)
    } catch (error) {
      onError(errorHandler(error))
    } finally {
      setEnviando(false)
    }
  }

  const onBtnUploadClicked = () => {
    if (!senha) return onError('Informe a senha do certificado antes de escolher o arquivo')
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = '.pfx,.p12'
    input.onchange = event => {
      const arquivo = event.target.files[0]
      if (arquivo) enviarCertificado(arquivo)
    }
    input.click()
  }

  const vencido = info && info.valido_ate && new Date(info.valido_ate) < new Date()

  return (
    <div className="p-grid" style={{ padding: 5 }}>
      <div className="p-col-12" style={{ fontSize: '0.85rem', color: '#666' }}>
        Certificado digital A1 (e-CNPJ) do emissor, usado para declarar, encerrar e cancelar o CIOT
        na ANTT em nome dele. O arquivo e a senha ficam cifrados no banco; o certificado precisa ser
        do mesmo CNPJ do emissor. Para enviar, informe a senha e escolha o arquivo no botão.
      </div>

      <div className="p-col-12">
        {carregando ? (
          <Loading size="sm" />
        ) : info ? (
          <div className="p-grid">
            <div className="p-md-3 p-col-6">
              <span style={estiloRotulo}>CNPJ</span>
              <Cnpj>{info.cnpj}</Cnpj>
            </div>
            <div className="p-md-5 p-col-6">
              <span style={estiloRotulo}>Titular</span>
              <span style={{ fontSize: '0.9rem' }}>{info.titular}</span>
            </div>
            <div className="p-md-2 p-col-6">
              <span style={estiloRotulo}>Válido de</span>
              <span style={{ fontSize: '0.9rem' }}>{formatarData(info.valido_de)}</span>
            </div>
            <div className="p-md-2 p-col-6">
              <span style={estiloRotulo}>Válido até</span>
              <span style={{ fontSize: '0.9rem', color: vencido ? 'red' : undefined }}>
                {formatarData(info.valido_ate)}
                {vencido ? ' (vencido)' : ''}
              </span>
            </div>
          </div>
        ) : (
          <span style={{ fontSize: '0.9rem', color: '#e67e22' }}>
            Nenhum certificado cadastrado: sem ele o emissor não declara CIOT pelo sistema.
          </span>
        )}
      </div>

      <div className="p-md-5 p-col-12">
        <InputText
          label="Senha do certificado:*"
          type="password"
          autoComplete="new-password"
          marginTop={0}
          value={senha}
          onChange={setSenha}
        />
      </div>
      <div className="p-md-7 p-col-12">
        <div style={{ fontSize: '0.8rem', marginBottom: 8, color: '#14B0BF' }}>
          Certificado (.pfx ou .p12)
        </div>
        <Btn isLoading={enviando} onClick={onBtnUploadClicked}>
          {info ? 'Trocar Certificado' : 'Upload Certificado'}
        </Btn>
      </div>
    </div>
  )
}
